export const qrCodeValueGenerator = (email, code) => {
  return `otpauth://totp/breathe%20hr:${email}?secret=${code}&issuer=breathe%20hr`;;
};
